import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, withKeys as _withKeys, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29508fa1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_task" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "项目名称：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "执行人：", -1))
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "审核人：", -1))
const _hoisted_11 = { class: "header_nr flexAlign" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "项目类型：", -1))
const _hoisted_13 = { class: "header_nr flexAlign" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "事项类型：", -1))
const _hoisted_15 = { class: "header_nr flexAlign" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "任务状态：", -1))
const _hoisted_17 = { class: "header_nr flexAlign" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "开始时间：", -1))
const _hoisted_19 = { class: "header_nr flexAlign" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "截止时间：", -1))
const _hoisted_21 = { class: "header_nr flexAlign" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "模糊查询：", -1))
const _hoisted_23 = {
  class: "header_nr flexAlign",
  style: {"margin-left":"20px"}
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("生成甘特图")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("批量创建任务")
const _hoisted_27 = {
  class: "header_nr flexAlign",
  style: {"margin":"10px 20px 0px 20px"}
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode("导入日事日毕Excel文件")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_30 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_31 = { class: "my-header" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "新建任务", -1))
const _hoisted_33 = { class: "qp" }
const _hoisted_34 = { class: "my-header" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "批量创建任务", -1))
const _hoisted_36 = { class: "qp" }
const _hoisted_37 = { class: "my-header" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务详情", -1))
const _hoisted_39 = { class: "my-header" }

import { useRouter,useRoute } from 'vue-router';
	import { onMounted,ref,nextTick,computed,watch } from 'vue';
	import { ElMessage } from 'element-plus';
	import { apiName } from '@/api/api';
	import { requestProjectAllList,requestAllTaskList } from '@/api/xmApi';
	import {
        requestGetAllConfig
    } from '@/api/configApi.js';
	import AddTask from '@/components/AddTask.vue';
	import TaskDetails from '@/components/TaskDetails.vue'
	import BatchAddTask from '@/components/BatchAddTask.vue';
	import GanttChart from '@/components/GanttChart.vue'
	import { Search, DataAnalysis, Close } from '@element-plus/icons-vue'
	
export default /*#__PURE__*/_defineComponent({
  name: 'AllTask',
  setup(__props) {

	const api = ref<string>(apiName)
	const router = useRouter()
	const route = useRoute()
	// 表格内容显示模式：true=单行（超出隐藏，悬停显示完整）；false=多行（换行完整展示）
	const singleLine = ref<boolean>(true)
	const list = ref([])
	const fileList = ref<UploadUserFile[]>([])
	const loading = ref<boolean>(false)
	const addShowTask = ref<boolean>(false)//添加任务
	const addTask = ref<boolean>(false)
	const batchShowTask = ref<boolean>(false)//批量创建
	const batchTask = ref<boolean>(false)
	const taskDetails = ref(false)//控制右侧弹窗
	const taskDetailsShow = ref(false)//控制右侧弹窗
	const form = ref({})

	const sxlxLists = ref<any[]>([])
	const projectlist = ref([])
	const taskid = ref(route.params.taskid)
	const yuqi =ref(route.params.yuqi);
	const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
	const pages = ref({
		totalCount:0
	})

	const getallprojectList = () => {
		requestProjectAllList({}).then((res:any)=>{
			projectlist.value=res.datalist;
		})
	}
	const search = ref({
		status:0,
		sxlx:"",
		projectname:"",
		operatorname:"",
		checkname:"",
		startdate1:"",
		startdate2:"",
		type1:0,
		liketxt:""
	})
	// ===== 表头排序（服务端排序：分页列表若用客户端排序只会排当前页，故交由后端 ORDER BY）=====
	// 前端列 prop -> 后端排序字段标识（后端用白名单映射为真实列，避免 SQL 注入）
	const sortPropMap: {[key:string]: string} = {
		'cell.projectname': 'projectname',
		'cell.type1': 'type1',
		'cell.tasktitle': 'tasktitle',
		'cell.operatorname': 'operatorname',
		'cell.checkname': 'checkname',
		'cell.enddate': 'enddate',
		'cell.priority2': 'priority2',
		// 已读列显示"已读/未读"，排序依据是实际读取时间
		'cell.operatorreadtime1': 'operatorreadtime',
		'cell.status': 'status'
	}
	const sortField = ref<string>('')
	const sortOrder = ref<string>('') // asc / desc
	const handleSortChange = ({ prop, order }: any) => {
		if (!order) {
			// 取消排序：恢复默认（按要求完成时间倒序）
			sortField.value = ''
			sortOrder.value = ''
		} else {
			sortField.value = sortPropMap[prop] || ''
			sortOrder.value = order === 'ascending' ? 'asc' : 'desc'
		}
		pageIndex.value = 1
		getTaskList()
	}
	const type1tostring = (val: number) =>{
		if(val==1){
			return  "项目售前"
		}
		if(val==2){
			return  "项目售中"
		}
		if(val==3){
			return  "项目售后"
		}
		if(val==4){
			return  "公司内部项目"
		}
		if(val==5){
			return  "周计划投产"
		}
	}
	const getStatus = computed(()=>{
		return function(status:number){
			let a = {
				1:"进行中",
				2:"关闭",
				3:"待审核",
				4:"完成",
				5:"逾期进行中",
				6:"逾期待审核"
			}
			return a[status]
		}
	})
	const getType = computed(()=>{
		return function(status:number){
			let b = {
				1:"primary",
				2:"danger",
				3:"warning",
				4:"success",
				5:"danger",
				6:"warning"
			}
			return b[status]
		}
	})
	// 列表行状态：结合任务截至时间(enddate)判断逾期
	const getRowStatus = (cell:any):number => {
		const status = cell.status ? Number(cell.status) : 0
		if (status === 1 || status === 3) {
			const end = cell.enddate ? String(cell.enddate).substring(0, 10) : ''
			const today = new Date().toISOString().slice(0, 10)
			if (end && end < today) {
				return status === 1 ? 5 : 6
			}
		}
		return status
	}
	const cancelDetails = () => {
		taskDetails.value = false
		getTaskList()
	}
	const cancelTask = (val:any) =>{
		addShowTask.value = false
		if(val){
			getTaskList()
		}
	}
	//批量创建任务（跨项目：不指定项目，由行内"所属项目"选择）
	const batchCreateTask = () => {
		batchTask.value = false
		nextTick(()=>{
			batchTask.value = true
		})
		batchShowTask.value = true
	}
	const cancelBatchTask = (val:any) => {
		batchShowTask.value = false
		if(val){
			getTaskList()
		}
	}
	const searchList = () =>{
		pageIndex.value = 1
		getTaskList();
	}
	const details = (row:any) => {
		form.value = row.cell
		taskDetailsShow.value = false
		nextTick(()=>{
			taskDetailsShow.value = true
		})
		taskDetails.value = true
	}
	//刷新列表
	const taskListsx = () => {
		getTaskList()
		taskDetails.value = false
	}
	//新建任务
	const createTask = () => {
		tasksx()
		addShowTask.value = true
	}
	const tasksx = () => {
		addTask.value = false
		nextTick(()=>{
			addTask.value = true
		})
	}
	onMounted(()=>{
		getallprojectList();
		getTaskList();
		getSxlx();
	})
	const getSxlx = () => {
		console.log("sxlx");
        requestGetAllConfig({
            type:"事项类型"
        }).then((res:any)=>{
            if(res.status === 1){
            	console.log(res.datalist);
                sxlxLists.value = res.datalist
            }
        })
    }
	const getTaskList = () => {
		loading.value = true
		requestAllTaskList({
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			projectid:taskid.value,
			projectname:search.value.projectname,
			operatorname:search.value.operatorname,
			checkname:search.value.checkname,
			type1:search.value.type1,
			sxlx:search.value.sxlx,
			status:search.value.status,
			startdate1:search.value.startdate1,
			startdate2:search.value.startdate2,
			yuqi:yuqi.value,
			liketxt:search.value.liketxt,
			sortfield:sortField.value,
			sortorder:sortOrder.value
		}).then((res:any)=>{
			for(var i=0;i<res.data.length;i++){
				if(res.data[i].cell.operatorreadtime==""){
					res.data[i].cell.operatorreadtime1="未读"
				}else{
					res.data[i].cell.operatorreadtime1="已读"
				}
			}
			list.value = res.data
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
	}
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getTaskList();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getTaskList();
	}
	// 甘特图：查看查询结果的所有任务
	const ganttShow = ref<boolean>(false)
	const ganttShowInner = ref<boolean>(false)
	const ganttKey = ref<number>(0)
// 弹窗关闭后卸载甘特图实例：避免再次打开时，新实例与旧实例/dialog 过渡动画在同一周期竞态，
// 触发 Vue 内部错误（insertBefore / Cannot destructure property 'bum' of null）
watch(ganttShow, (v: boolean) => {
	if (!v) ganttShowInner.value = false
})
	const ganttTasks = ref<any[]>([])
	const showGanttAll = () => {
		// 用当前查询条件拉取全部（不分页）任务
		requestAllTaskList({
			pageIndex: 1,
			pageSize: 100000,
			projectid: taskid.value,
			projectname: search.value.projectname,
			operatorname: search.value.operatorname,
			checkname: search.value.checkname,
			type1: search.value.type1,
			sxlx: search.value.sxlx,
			status: search.value.status,
			startdate1: search.value.startdate1,
			startdate2: search.value.startdate2,
			yuqi: yuqi.value,
			liketxt: search.value.liketxt,
			// 沿用列表当前排序，保证甘特图顺序与列表一致
			sortfield: sortField.value,
			sortorder: sortOrder.value
		}).then((res: any) => {
			const data = Array.isArray(res.data) ? res.data : []
			if (data.length === 0) {
				ElMessage.warning('当前查询条件下没有可生成甘特图的任务')
				return
			}
			ganttTasks.value = data
			ganttShowInner.value = true
			ganttKey.value++
			ganttShow.value = true
			})
			}
			// 甘特图点击任务：打开任务详情（item 已展开为 cell 字段，兼容 {cell:{...}} 形式）
			// 注意：必须定义在 setup 顶层（不能嵌在 showGanttAll 内部），否则模板拿不到该函数
			const onGanttTaskClick = (item: any) => {
			form.value = item && item.cell ? item.cell : item
			taskDetailsShow.value = false
			nextTick(() => {
				taskDetailsShow.value = true
			})
			taskDetails.value = true
			}
			const back = () =>{
		router.go(-1)
	}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_select, {
              size: "small",
              filterable: "",
              modelValue: search.value.projectname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.projectname) = $event)),
              placeholder: "请选择",
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectlist.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: `${item.code}-${item.projectname}(${type1tostring(item.type1)})`,
                    value: `${item.projectname}`,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.operatorname,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.value.operatorname) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.checkname,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search.value.checkname) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_el_select, {
              modelValue: search.value.type1,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((search.value.type1) = $event)),
              size: "small",
              placeholder: "请选择",
              style: {"width":"80px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: 0
                }),
                _createVNode(_component_el_option, {
                  label: "项目售前",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "项目售中",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "项目售后",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "公司内部项目",
                  value: 4
                }),
                _createVNode(_component_el_option, {
                  label: "周计划投产",
                  value: 5
                }),
                _createVNode(_component_el_option, {
                  label: "除周计划投产外任务",
                  value: -5
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_el_select, {
              modelValue: search.value.sxlx,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((search.value.sxlx) = $event)),
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sxlxLists.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.value,
                    value: `${item.value}`,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_el_select, {
              modelValue: search.value.status,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((search.value.status) = $event)),
              size: "small",
              placeholder: "请选择",
              style: {"width":"80px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "未关闭",
                  value: 0
                }),
                _createVNode(_component_el_option, {
                  label: "进行中",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "关闭",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "提交待审核",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "完成",
                  value: 4
                }),
                _createVNode(_component_el_option, {
                  label: "逾期进行中",
                  value: 5
                }),
                _createVNode(_component_el_option, {
                  label: "逾期待审核",
                  value: 6
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_date_picker, {
              modelValue: search.value.startdate1,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((search.value.startdate1) = $event)),
              type: "date",
              placeholder: "开始时间",
              "value-format": "YYYY-MM-DD",
              style: {"width":"120px"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_el_date_picker, {
              modelValue: search.value.startdate2,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((search.value.startdate2) = $event)),
              type: "date",
              placeholder: "截止时间",
              "value-format": "YYYY-MM-DD",
              style: {"width":"120px"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.liketxt,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((search.value.liketxt) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[11] || (_cache[11] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _unref(Search),
              onClick: _cache[12] || (_cache[12] = ($event: any) => (searchList()))
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              plain: "",
              type: "success",
              size: "small",
              icon: _unref(DataAnalysis),
              onClick: _cache[13] || (_cache[13] = ($event: any) => (showGanttAll()))
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              plain: "",
              type: "warning",
              size: "small",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (batchCreateTask()))
            }, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (singleLine.value = !singleLine.value))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(singleLine.value ? '切换多行显示' : '切换单行显示'), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_el_upload, {
              action: `${api.value}/project/uploadfile1`,
              "file-list": fileList.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["action", "file-list"]),
            _createElementVNode("a", {
              href: "javascript:void(0)",
              style: _normalizeStyle([{marginLeft:'10px'}, {"color":"#009fff","font-size":"12px","text-decoration":"underline","cursor":"pointer"}]),
              onclick: "window.open('/pages/template/日事日毕导入模板.xlsx')"
            }, "下载日事日毕导入模板")
          ])
        ])
      ])
    ]),
    _hoisted_29,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onCellClick: details,
      data: list.value,
      class: _normalizeClass({'multi-line': !singleLine.value}),
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'},
      onSortChange: handleSortChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "40",
          label: "",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.projectname",
          label: "项目名称",
          width: "100",
          "show-overflow-tooltip": singleLine.value,
          sortable: "custom"
        }, null, 8, ["show-overflow-tooltip"]),
        _createVNode(_component_el_table_column, {
          prop: "cell.type1",
          label: "事项类型",
          width: "100",
          "show-overflow-tooltip": singleLine.value,
          sortable: "custom"
        }, null, 8, ["show-overflow-tooltip"]),
        _createVNode(_component_el_table_column, {
          prop: "cell.tasktitle",
          label: "任务标题",
          width: "150",
          "show-overflow-tooltip": singleLine.value,
          sortable: "custom"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", {
              class: "normal",
              style: _normalizeStyle(singleLine.value ? {whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'} : {whiteSpace:'pre-wrap',wordBreak:'break-all'})
            }, _toDisplayString(scope.row.cell.tasktitle), 5)
          ]),
          _: 1
        }, 8, ["show-overflow-tooltip"]),
        _createVNode(_component_el_table_column, {
          prop: "cell.operatorname",
          label: "执行人",
          width: "100",
          "show-overflow-tooltip": singleLine.value,
          sortable: "custom"
        }, null, 8, ["show-overflow-tooltip"]),
        _createVNode(_component_el_table_column, {
          prop: "cell.checkname",
          label: "审核人",
          width: "100",
          "show-overflow-tooltip": singleLine.value,
          sortable: "custom"
        }, null, 8, ["show-overflow-tooltip"]),
        _createVNode(_component_el_table_column, {
          prop: "cell.enddate",
          label: "要求完成时间",
          width: "130",
          "show-overflow-tooltip": singleLine.value,
          sortable: "custom"
        }, null, 8, ["show-overflow-tooltip"]),
        _createVNode(_component_el_table_column, {
          prop: "cell.priority2",
          label: "优先级",
          width: "100",
          "show-overflow-tooltip": singleLine.value,
          sortable: "custom"
        }, null, 8, ["show-overflow-tooltip"]),
        _createVNode(_component_el_table_column, {
          prop: "cell.operatorreadtime1",
          label: "执行人已读",
          width: "130",
          "show-overflow-tooltip": singleLine.value,
          sortable: "custom"
        }, null, 8, ["show-overflow-tooltip"]),
        _createVNode(_component_el_table_column, {
          prop: "cell.status",
          label: "状态",
          width: "110",
          sortable: "custom"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: _unref(getType)(getRowStatus(scope.row.cell))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getStatus)(getRowStatus(scope.row.cell))), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "class"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[16] || (_cache[16] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[17] || (_cache[17] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      top: "5vh",
      modelValue: addShowTask.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((addShowTask).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (addShowTask.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (addTask.value)
          ? (_openBlock(), _createBlock(AddTask, {
              key: 0,
              id: taskid.value,
              onCancelTask: cancelTask
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(_component_el_dialog, {
        modelValue: batchShowTask.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((batchShowTask).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (batchShowTask.value=false))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Close))
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (batchTask.value)
            ? (_openBlock(), _createBlock(BatchAddTask, {
                key: 0,
                "project-id": 0,
                onCancelTask: cancelBatchTask
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createVNode(_component_el_dialog, {
        modelValue: taskDetails.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((taskDetails).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (cancelDetails()))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Close))
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (taskDetailsShow.value)
            ? (_openBlock(), _createBlock(TaskDetails, {
                key: 0,
                form: form.value,
                onTaskListsx: taskListsx
              }, null, 8, ["form"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        top: "5vh",
        modelValue: ganttShow.value,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((ganttShow).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", null, "查询结果甘特图（共 " + _toDisplayString(ganttTasks.value.length) + " 个任务）", 1),
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (ganttShow.value=false))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Close))
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (ganttShowInner.value)
            ? (_openBlock(), _createBlock(GanttChart, {
                key: ganttKey.value,
                tasks: ganttTasks.value,
                onOpentask: onGanttTaskClick
              }, null, 8, ["tasks"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})